import { FC, ReactNode } from 'react';
import { motion } from 'framer-motion';

import './TeamShell.scss';
import { teamCardVariants } from '../constants';

interface TeamShellProps {
  topChrome: ReactNode;
  sideNav: ReactNode;
  children: ReactNode;
}

const TeamShell: FC<TeamShellProps> = ({ topChrome, sideNav, children }) => {
  return (
    <motion.section
      key="team-shell"
      className="team-shell"
      variants={teamCardVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      {topChrome}
      <div className="team-shell__app-body">
        {sideNav}
        {children}
      </div>
    </motion.section>
  );
};

export default TeamShell;
